import Vue from 'vue'
import App from './App.vue'

import 'babel-polyfill'

import promise from 'es6-promise'
promise.polyfill()

Vue.config.productionTip = false

// router
import vueRouter from 'vue-router'
import createRouter from './router/router'
Vue.use(vueRouter)
let router = createRouter();

// axios
import axios from 'axios'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.prototype.axios = axios

// toast
import toastRegistry from './toast/index'
Vue.use(toastRegistry)

// vue-photo-preview
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview, {
    fullscreenEl: false, //控制是否显示右上角全屏按钮
    // closeEl: false, //控制是否显示右上角关闭按钮
    // tapToClose: true, //点击滑动区域应关闭图库
    // shareEl: false, //控制是否显示分享按钮
    // zoomEl: false, //控制是否显示放大缩小按钮
    // counterEl: false, //控制是否显示左上角图片数量按钮
    // tapToToggleControls: true, //点击应切换控件的可见性
    // clickToCloseNonZoomable: true, //点击图片应关闭图库，仅当图像小于视口的大小时
    // indexIndicatorSep: ' / '//图片数量的分隔符
})

// vuex
import Vuex from 'vuex'
import createStore from './store/store';
Vue.use(Vuex)
let store = createStore();


// i18n
import VueI18n from 'vue-i18n'
import createLang from './lang/i18n';
Vue.use(VueI18n)
let i18n = createLang();

// \r\n转<br>
import utils from './utils/utils'
Vue.use(utils);

// swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import style
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)


// import panZoom from 'vue-panzoom'
// Vue.use(panZoom);

// vue-meta
import VueMeta from 'vue-meta';
Vue.use(VueMeta, {
    refreshOnceOnNavigation: true // 切换页面时刷新 head 信息
})

// 
new Vue({
    i18n,
    store,
    router,
    render: h => h(App),
}).$mount('#app')
